module.exports = __webpack_public_path__ + "img/charity_11.a06b33d0.png";